module.exports = __webpack_public_path__ + "img/innovator-enthusiast-1.afd54946.svg";